module.exports = __webpack_public_path__ + "static/media/chinmay-patel.d233ccb8.jpg";